import { Navigation } from "./Navigation"
import { Hero } from "./Hero"
import { Features } from "./Features"
import { About } from "./About"
import { Contact } from "./Contact"
import { Footer } from "./Footer"

export function LandingPage() {
  return (
    <div className="min-h-screen" style={{ scrollBehavior: "smooth" }}>
      <Navigation />
      <Hero />
      <Features />
      <About />
      <Contact />
      <Footer />
    </div>
  )
}
